if (!customElements.get('sticky-add-to-cart')) {
    customElements.define(
      'sticky-add-to-cart',
  
      class StickyAddToCart extends HTMLElement {
        constructor() {
          super();         
            this.productForm = document.querySelector("product-info product-form");
            this.stickyAddToCartButton = this.querySelector('.add-to-cart-sticky');
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

            this.init();
        }
        
        init() {
          this.stickyAddToCartButton.addEventListener("click", this.handleUpsellAddToCart.bind(this));
          document.addEventListener("scroll", this.handleStickyElementWhenScrolling.bind(this));

          // handle sticky element on load
          this.handleStickyElementWhenScrolling.bind(this);
        }
  
        handleStickyElementWhenScrolling() {
          const headerOffsetHeight = document.querySelector("header").offsetHeight;
          const addToCartButtonOffset = this.productForm.getBoundingClientRect().top + this.productForm.offsetHeight - headerOffsetHeight;
  
          if (addToCartButtonOffset <= 0) {
            this.style.bottom = '0';
          } else {
            this.style.bottom = '-100%';
          }
        }

        updateDataOnVariantChange(variant) {
            // update prices
            const productPrice = this.querySelector(".sticky-product-price--regular");
            const productSalePrice = this.querySelector(".sticky-product-price--sale");

            if (variant.compare_at_price > variant.price) {
                productSalePrice.removeAttribute("hidden");
                productPrice.textContent = "$" + variant.price / 100;
                productSalePrice.textContent = "$" + variant.compare_at_price / 100;
            } else {
                productSalePrice.setAttribute("hidden", true);
                productPrice.textContent = "$" + variant.price / 100;
            }

            // update image
            const productImage = this.querySelector(".sticky-product-image img");
            
            if(variant.featured_image) {
                const imageExtension = this.getImageExtension(variant.featured_image.src);
                const optimizedVariantImage = variant.featured_image.src.split("." + imageExtension)[0] + "_200x." + imageExtension;
                productImage.setAttribute("src", optimizedVariantImage);
            }

            // update add to cart button
            if (variant.available) {
                this.stickyAddToCartButton.querySelector("input").value = variant.id;
                this.stickyAddToCartButton.querySelector("[data-add-to-cart-text]").textContent = "Add To Cart";
                this.stickyAddToCartButton.removeAttribute("disabled");
            } else {
                this.stickyAddToCartButton.setAttribute("disabled", true);
                this.stickyAddToCartButton.querySelector("[data-add-to-cart-text]").textContent = "Sold Out";
            }
        }

        getImageExtension(image) {
            const parts = image.split('.');
            const extensionWithQueryParams = parts[parts.length - 1];
            const extensionParts = extensionWithQueryParams.split('?');
            return extensionParts[0];
        }
  
        handleUpsellAddToCart(event) {
            event.preventDefault();
            const productId = event.target.querySelector(".sticky-product-id-input").value;
            const inventoryLeftValue = parseInt(this.querySelector('.inventory-left').value);
            const quantityField = this.querySelector('.quantity__input')
            const quantityFieldValue = parseInt(quantityField.value);

            if (!quantityFieldValue || quantityFieldValue <= 0) {
                quantityField.value = 1;
            }

            if (quantityFieldValue > inventoryLeftValue) {
                quantityField.value = inventoryLeftValue;
            }
    
            event.target.setAttribute("disabled", true);
    
            const formData = {
                items: [
                    {
                        id: productId,
                        quantity: quantityField.value,
                    }
                ]
            };

            const config = fetchConfig('javascript');
  
            if (this.cart) {
                formData.sections = this.cart.getSectionsToRender().map((section) => section.id)
                formData.sections_url = window.location.pathname;
                this.cart.setActiveElement(document.activeElement);
            }

            config.body = JSON.stringify(formData);
        
            fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                        source: 'order-item',
                        errors: response.errors || response.description,
                        message: response.message,
                    });

                    const message = response.description;
                    const errorMessageWrapper = this.querySelector(".product-form__error-message-wrapper");
                    const errorMessageElement = errorMessageWrapper.querySelector(".product-form__error-message");
                    
                    errorMessageWrapper.removeAttribute("hidden");
                    errorMessageElement.textContent = message;

                    setTimeout(() => {
                        errorMessageWrapper.setAttribute("hidden", true);
                    }, 4000)
                    
                    return
                } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                }
                if (!this.error) {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'sticky-product',
                        cartData: response,
                    });
    
                    this.error = false;
                    this.cart.renderContents(response);
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                event.target.removeAttribute("disabled");
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            });
        }
      }
    )
  }